import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import MyPageSidebar from "./MyPageSidebar";
import MyPageHome from "./MyPageHome";
import MyPageAccount from "./MyPageAccount";
import MyPageGallery from "./MyPageGallery";
import "./MyPage.css";
import MyPageStorage from "./MyPageStorage";
import MyPageOrders from "./MyPageOrders";
import MyPageAddress from "./MyPageAddress";
import MyPageReturns from "./MyPageReturns";
import { PRICING_OPEN } from "../../config/features";
import Support from "../../components/Support";

/* 주문 내역·취소/교환/환불·배송지 관리 탭은 메뉴에서 숨김 (배송지: 2026-10-16 김현비 — 주문이 네이버로 옮겨가 쓸 일이 없음) (화면·이벤트로 여는 경로는 그대로 동작) */
const MOBILE_TABS = [
  { key: "drive",    labelKey: "mypage.sidebar.drive" },
  { key: "gallery",  labelKey: "mypage.sidebar.gallery" },
  { key: "account",  labelKey: "mypage.sidebar.account" },
  ...(PRICING_OPEN ? [{ key: "storage", labelKey: "mypage.sidebar.payment" }] : []),
];

export default function MyPageLayout() {
  const [activeTab, setActiveTab] = useState("drive");
  const { t } = useTranslation();
  const activeTabRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (e.detail) setActiveTab(e.detail);
    };
    window.addEventListener("mypage:changeTab", handler);
    return () => window.removeEventListener("mypage:changeTab", handler);
  }, []);

  // 활성 탭 버튼을 탭 줄 안에서만 가운데로 (페이지 전체가 옆으로 밀리지 않게)
  useEffect(() => {
    const btn = activeTabRef.current;
    const nav = btn?.parentElement;
    if (!btn || !nav || nav.scrollWidth <= nav.clientWidth) return;
    nav.scrollTo({ left: btn.offsetLeft - (nav.clientWidth - btn.offsetWidth) / 2, behavior: "smooth" });
  }, [activeTab]);

  return (
    <div className="mypage-layout">
      <div className="mypage-shell">
        <MyPageSidebar activeTab={activeTab} onChangeTab={setActiveTab} />

        <nav className="mypage-mobile-nav">
          {MOBILE_TABS.map((tab) => (
            <button
              key={tab.key}
              ref={activeTab === tab.key ? activeTabRef : null}
              className={activeTab === tab.key ? "active" : ""}
              onClick={() => setActiveTab(tab.key)}
            >
              {t(tab.labelKey)}
            </button>
          ))}
        </nav>

        <div className="mypage-content">
          {activeTab === "drive"    && <MyPageHome />}
          {activeTab === "account"  && <MyPageAccount />}
          {activeTab === "gallery"  && <MyPageGallery />}
          {PRICING_OPEN && activeTab === "storage" && <MyPageStorage />}
          {activeTab === "orders"   && <MyPageOrders />}
          {activeTab === "address"  && <MyPageAddress />}
          {activeTab === "returns"  && <MyPageReturns />}
          <Support className="mypage-support" />
        </div>
      </div>
    </div>
  );
}
